import React, { useState, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { useAsyncDebounce } from 'react-table';

import DateTimePicker from './Components/DateTimePicker';
import { convertDateToJsonFormat } from './Utilities/useDateUtils';

function DateRange({ dateFilter, setDateFilter }) {
    const { t } = useTranslation();
    const [jsFromDate, setJSFromDate] = useState(dateFilter.from && new Date(dateFilter.from));
    const [jsToDate, setJSToDate] = useState(dateFilter.to && new Date(dateFilter.to));

    const handleChange = useAsyncDebounce((fromDate, toDate) => {
        setDateFilter(prevState => {
            return {
                ...prevState,
                from: fromDate ? convertDateToJsonFormat(fromDate) : null,
                to: toDate ? convertDateToJsonFormat(toDate) : null
            };
        });
    }, 500);

    useEffect(() => {
        setJSFromDate(dateFilter.from && new Date(dateFilter.from));
        setJSToDate(dateFilter.to && new Date(dateFilter.to));
    }, [dateFilter.from, dateFilter.to])

    return (
        <Row>
            <Col xs={12} xl>
                <Form.Group as={Row} controlId="dateFrom">
                    <Form.Label column xs={2} sm={4}>{t("Filter.DateFrom")}:</Form.Label>
                    <Col xs={10} sm={8}>
                        <DateTimePicker name="dateFrom" dateTime={jsFromDate} handleDateSelect={(date) => handleChange(date, jsToDate)} dateOnly isClearable />
                    </Col>
                </Form.Group>
            </Col>
            <Col xs={12} xl>
                <Form.Group as={Row} controlId="dateTo">
                    <Form.Label column xs={2} sm={4}>{t("Filter.DateTo")}:</Form.Label>
                    <Col xs={10} sm={8}>
                        <DateTimePicker name="dateTo" dateTime={jsToDate} handleDateSelect={(date) => handleChange(jsFromDate, date)} dateOnly isClearable />
                    </Col>
                </Form.Group>
            </Col>
        </Row>
            
    );
}

export default DateRange;